import { LookupId } from '../../lists/lookups.enum';
import { LookupKeys } from 'ag-common-lib/lib/models/crm/lookup.model';

export enum TShirtSizesKeys {
  /**
   * @deprecated
   */
  tShirtSize = 'tShirtSize',
  /**
   * @deprecated
   */
  tShirtSizeOther = 'tShirtSizeOther',
  /**
   * @deprecated
   */
  unisexTShirtSize = 'unisexTShirtSize',
  /**
   * @deprecated
   */
  unisexTShirtSizeOther = 'unisexTShirtSizeOther',

  unisextShirtSize = 'unisextShirtSize', // Renamed from Unisex T-Shirt Size
  genderTShirtSize = 'genderTShirtSize', // Renamed from T-Shirt Size

  tShirtCategory = 'tShirtCategory',
  shirtCategory = 'shirtCategory',
}

export const TShirtSizesMap = {
  [TShirtSizesKeys.tShirtSize]: 'T-Shirt Size',
  [TShirtSizesKeys.tShirtSizeOther]: 'T-Shirt Size Other',
  [TShirtSizesKeys.unisexTShirtSize]: 'Unisex T-Shirt Size',
  [TShirtSizesKeys.unisexTShirtSizeOther]: 'Unisex T-Shirt Size Other',

  [TShirtSizesKeys.unisextShirtSize]: 'T-Shirt Size',
  [TShirtSizesKeys.genderTShirtSize]: 'Shirt Size',
  [TShirtSizesKeys.tShirtCategory]: 'T-Shirt Category',
  [TShirtSizesKeys.shirtCategory]: 'Shirt Size Category',
};

/**
 * Categories for T-Shirt (Unisex)
 */
export enum TShirtCategory {
  adult = 'Adult',
  youth = 'Youth',
}

/**
 * Categories for Shirt (Gender-oriented)
 */
export enum ShirtCategory {
  men = 'Men',
  women = 'Women',
}

export const TShirtCategoryLookup = [
  {
    [LookupKeys.value]: TShirtCategory.adult,
    [LookupKeys.description]: 'Adult',
  },
  {
    [LookupKeys.value]: TShirtCategory.youth,
    [LookupKeys.description]: 'Youth',
  },
];

export const ShirtCategoryLookup = [
  {
    [LookupKeys.value]: ShirtCategory.men,
    [LookupKeys.description]: 'Men',
  },
  {
    [LookupKeys.value]: ShirtCategory.women,
    [LookupKeys.description]: 'Women',
  },
];

export class TShirtSizes {
  [TShirtSizesKeys.unisextShirtSize]?: LookupId<'TShirtAdult'> | LookupId<'TShirtYouth'> = null;
  [TShirtSizesKeys.genderTShirtSize]?: LookupId<'ShirtMen'> | LookupId<'ShirtWomen'> = null;
}

export class TShirtSizesForm extends TShirtSizes {
  [TShirtSizesKeys.tShirtCategory]?: TShirtCategory;
  [TShirtSizesKeys.shirtCategory]?: ShirtCategory;
}

export const TSHIRT_SIZES_LOOKUP = [
  TShirtSizesKeys.tShirtSize,
  TShirtSizesKeys.tShirtSizeOther,
  TShirtSizesKeys.unisexTShirtSize,
  TShirtSizesKeys.unisexTShirtSizeOther,
  TShirtSizesKeys.unisextShirtSize,
  TShirtSizesKeys.genderTShirtSize,
  TShirtSizesKeys.tShirtCategory,
  TShirtSizesKeys.shirtCategory
].map(value => {
  return {
    [LookupKeys.value]: value,
    [LookupKeys.description]: TShirtSizesMap[value],
  };
});
